import { render } from "./Welcome.vue?vue&type=template&id=f05d77a0"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"
script.render = render

export default script